/**
 * @description: 会员办卡费用报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="mr-hbf-report">
        <div class="member-zf-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="zfTime">
                        <input type="text" class="form-control laydate-icon" v-model="zfStartTime" /> -
                        <input type="text" class="form-control laydate-icon" v-model="zfEndTime" />
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="zfShop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-4">支付状态:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择" ref="zfPaymentstatus">
                        <option value="100">全部</option>
                        <option value="-1">待支付</option>
                        <option value="1">已付款</option>
                        <option value="4">已退款</option>
                    </select>
                </div>
                <label class="list-label-3">操作人:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="zf_admin" data-placeholder="请选择操作人"></select>
                </div>
            </div>
            <div class="row">
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="zfQuery_conditions">
                        <option value="kh_id">会员卡号</option>
                        <option value="phone_numb">会员手机号</option>
                        <option value="dh_id">充值单号</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="zfSearch_info" :placeholder="zfEmployeeinput">
                </div>
                <label class="list-label-4">支付类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择支付类型" ref="zf_paytype"></select>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitZfTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getZfExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="zfList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="zfExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='zfExport_allcheck' @click='zfExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='zfExport_checkModel' value="create_time">
                            <label>注册时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='zfExport_checkModel' value="id">
                            <label>办卡费用单号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='zfExport_checkModel' value="shop_name">
                            <label>收款门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='zfExport_checkModel' value="vip_card">
                            <label>会员卡号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='zfExport_checkModel' value="vip_mobile">
                            <label>会员手机号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='zfExport_checkModel' value="registration_fee">
                            <label>办卡费用</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='zfExport_checkModel' value="admin_name">
                            <label>操作人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='zfExport_checkModel' value="pay_platform">
                            <label>支付类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='zfExport_checkModel' value="status">
                            <label>支付状态</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='zfExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='zfExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                zfStartTime: "",
                zfEndTime: "",
                zfEmployeeinput: '请输入会员卡号',
                zfSearch_field: "kh_id",
                zfSearch_info: "",
                zfExport_allcheck: false,
                c_zfExport_allcheck: false,
                zfExport_checkModel: [],
                zfExport_checkData: ['create_time', 'id', 'shop_name', 'vip_card', 'vip_mobile', 'registration_fee', 'admin_name', 'pay_platform', 'status'],
                zfExport_type: 1,
            }
        },
        watch: {
            zfExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.zfExport_checkModel.length >= this.zfExport_checkData.length) {
                        this.zfExport_allcheck = true;
                        this.c_zfExport_allcheck = true;
                    } else {
                        this.zfExport_allcheck = false;
                        this.c_zfExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.zfStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.zfEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.innitDate(); // 日期
            // 支付状态
            $(_this.$refs.zfPaymentstatus).select2({
                minimumResultsForSearch: -1,
                language: "zh-CN",
                width: '100%'
            });
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 下拉选项
            $(_this.$refs.zfQuery_conditions).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1
            }).change(function() {
                _this.zfSearch_field = $(this).val();
                if(_this.zfSearch_field == 'kh_id') {
                    _this.zfEmployeeinput = '请输入会员卡号';
                } else if(_this.zfSearch_field == 'phone_numb') {
                    _this.zfEmployeeinput = '请输入会员手机号';
                } else if(_this.zfSearch_field == 'dh_id') {
                    _this.zfEmployeeinput = '请输入充值单号';
                }
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.zfStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.zfEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.zfStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.zfEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.zfTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.zfStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.zfEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.zfShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.getPaytype(e.params.data.id);
                                // 操作人
                                _this.getAdmin(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id)
                            });
                            // 获取支付类型
                            _this.getPaytype(data.response.result[1].id);
                            $(_this.$refs.zfShop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id)
                            // 操作人
                            _this.getAdmin($(_this.$refs.zfShop).val());
                            _this.innitZfTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取支付类型
            getPaytype: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Order/getAllPayPlatform",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.paytype = [{id: ' ', text: '全部'}];
                            let value = data.response.data;
                            for(var key in value) {
                                _this.paytype.push({id: key, text: value[key]});
                            }
                            $(_this.$refs.zf_paytype).html('');
                            $(_this.$refs.zf_paytype).select2({
                                data: _this.paytype,
                                allowClear: true,
                                minimumResultsForSearch: -1
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取操作人数据
            getAdmin: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['user_info'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.zf_admin).html("");
                            $(_this.$refs.zf_admin).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },



            // 初始化会员办卡费用报表表格
            innitZfTable: function() {
                let _this = this;
                $(_this.$refs.zfList).bootstrapTable('destroy');
                $(_this.$refs.zfList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getZfList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "create_time",
                        title: "注册时间",
                        width: "100"
                    }, {
                        field: "id",
                        title: "办卡费用单号",
                        width: "110"
                    }, {
                        field: "shop_name",
                        title: "收款门店",
                        width: "130",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "vip_card",
                        title: "会员卡号",
                        width: "110"
                    }, {
                        field: "vip_mobile",
                        title: "会员手机号",
                        width: "10%"
                    }, {
                        field: "registration_fee",
                        title: "办卡费用",
                        width: "9%"
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "9%"
                    }, {
                        field: "pay_platform",
                        title: "支付类型",
                        width: "9%"
                    }, {
                        field: "status",
                        title: "支付状态",
                        width: "9%"
                    }]
                });
            },
            // 获取会员办卡费用列表
            getZfList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.zfShop).val(),
                    status = $(_this.$refs.zfPaymentstatus).val(),
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }

                let vip_card = '',
                    vip_mobile = '',
                    id = '';
                if(_this.zfSearch_field == 'kh_id') {
                    vip_card = _this.zfSearch_info
                } else if(_this.zfSearch_field == 'phone_numb') {
                    vip_mobile = _this.zfSearch_info
                } else if(_this.zfSearch_field == 'dh_id') {
                    id = _this.zfSearch_info
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.zfStartTime,
                            "end_time": _this.zfEndTime,
                            "shop_id": shop_id,
                            "status": status == '100' ? "" : status,
                            "admin_id": $.trim($(_this.$refs.zf_admin).val()),
                            "vip_card": vip_card,
                            "vip_mobile": vip_mobile,
                            "id": id,
                            "pay_platform": $.trim($(_this.$refs.zf_paytype).val())
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getVipRegisterOrderList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getZfExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/vipRegisterExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.zfExport_checkModel = data.response.result.export_fields;
                                _this.zfExport_type = data.response.result.export_type;
                            } else {
                                _this.zfExport_checkModel = _this.zfExport_checkData;
                                _this.zfExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.zfExport_alert)
                }, function() {
                    _this.exportZfList();
                });
            },
            // 导出字段全选
            zfExportCheckedAll: function() {
                let _this = this;
                _this.zfExport_allcheck = _this.c_zfExport_allcheck;
                if(!_this.zfExport_allcheck) { // 实现全选
                    _this.zfExport_checkModel = [];
                    _this.zfExport_checkData.forEach(function(item) {
                        _this.zfExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.zfExport_checkModel = [];
                }
            },
            // 确定“导出”
            exportZfList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.zfShop).val(),
                    status = $(_this.$refs.zfPaymentstatus).val();
                status = status == '100' ? "" : status;
                let export_fields = JSON.stringify(_this.zfExport_checkModel);
                let vip_card = '',
                    vip_mobile = '',
                    id = '';
                if(_this.zfSearch_field == 'kh_id') {
                    vip_card = _this.zfSearch_info
                } else if(_this.zfSearch_field == 'phone_numb') {
                    vip_mobile = _this.zfSearch_info
                } else if(_this.zfSearch_field == 'dh_id') {
                    id = _this.zfSearch_info
                }
                window.location.href = Vue.ctUrl + "FinanceReport/vipRegisterExport?" +
                    "&start_time=" + _this.zfStartTime +
                    "&end_time=" + _this.zfEndTime +
                    "&shop_id=" + shop_id +
                    "&status=" + status +
                    "&admin_id=" + $.trim($(_this.$refs.zf_admin).val()) +
                    "&vip_card=" + vip_card +
                    "&vip_mobile=" + vip_mobile +
                    "&id=" + id +
                    "&pay_platform=" + $.trim($(_this.$refs.zf_paytype).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.zfExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .member-zf-list {
        table {
            word-break: break-all;
        }
    }
</style>